import { debounce } from './helpers';
import initSwiper from '../components/swiper-init';

export default class Functions {
    /**
     * Toggles the `scroll-header` class on the header element
     * based on the vertical scroll position of the page.
     *
     * - Adds the `scroll-header` class if the page is scrolled more than 100px.
     * - Removes the `scroll-header` class if the page is scrolled less than 100px.
     *
     * Requirements:
     * - The header element must have the class `header`.
     * - The `scroll-header` class should be defined in CSS to apply desired styles.
     */
    toggleScrollHeader() {
        const header = document.querySelector('.site-header');

        if (!header) return;

        window.document.addEventListener(
            'scroll',
            debounce(() => {
                const operationType =
                    Math.floor(window.scrollY) > 10 ? 'add' : 'remove';
                header.classList[operationType]('scroll-header');
            }, 10)
        );

        {
            // Detect Initial scroll of page
            const operationType =
                Math.floor(window.scrollY) > 100 ? 'add' : 'remove';
            header.classList[operationType]('scroll-header');
        }
    }

    /**
     * Toggles the visibility of the menu and manages page scrolling.
     *
     * - When the menu button is clicked, the menu element's visibility is toggled by adding/removing the `show` class.
     * - The `overflow-hidden` class is toggled on the `<html>` element to disable or enable page scrolling.
     *
     * Requirements:
     * - The menu button must have the class `js-menu-btn`.
     * - The menu container must have the class `js-menu-wrapper`.
     * - Styles for the `show` and `overflow-hidden` classes should be defined in CSS.
     */
    toggleMenuVisibility() {
        const menuIcon = document.querySelectorAll('.js-menu-btn');
        const menu = document.querySelector('.js-main-menu');

        if (!menu || !menuIcon) return;

        menuIcon &&
            menuIcon.forEach((item) => {
                item.addEventListener('click', () => {
                    menu.classList.toggle('show');
                    document.documentElement.classList.toggle(
                        'overflow-hidden'
                    );
                });
            });
    }

    /**
     * Sets the padding-top of a target element based on the height of the header.
     *
     * @param {string} headerSelector - CSS selector for the header element.
     * @param {string} targetSelector - CSS selector for the target element.
     */
    setPaddingTopBasedOnHeaderHeight(headerSelector, targetSelector) {
        const header = document.querySelector(headerSelector);
        const target = document.querySelector(targetSelector);

        if (!header || !target) {
            console.error('Header or target element not found');
            return;
        }

        const headerHeight = header?.offsetHeight;
        target.style.paddingTop = `${headerHeight + 40}px`;

        const documentOwner = target.ownerDocument;

        documentOwner.defaultView.addEventListener(
            'resize',
            debounce(() => {
                const updatedHeaderHeight = header.offsetHeight;
                target.style.paddingTop = `${updatedHeaderHeight + 40}px`;
            }, 100)
        );
    }

    similarSlider() {
        const similarSliders = document.querySelectorAll('.js-similar-slider');

        if (similarSliders.length) {
            similarSliders.forEach((item) => {
                initSwiper(item);
            });
        }
    }

    anchorLinks() {
        const anchorBlocks = document.querySelectorAll('.anchor-block');
        const anchorLinks = document.querySelectorAll('.js-anchor-link');

        function setActiveAnchor(id) {
            anchorLinks.forEach((link) => {
                if (link.getAttribute('href') === `#${id}`) {
                    link.classList.add('active');
                } else {
                    link.classList.remove('active');
                }
            });
        }

        function checkVisibility() {
            const middleScreen = window.innerHeight / 2;
            let activeBlockId = null;

            anchorBlocks.forEach((block) => {
                const rect = block.getBoundingClientRect();
                const blockTop = rect.top;
                const blockBottom = rect.bottom;

                if (blockTop < middleScreen && blockBottom > middleScreen) {
                    activeBlockId = block.id;
                }
            });

            setTimeout(() => {
                setActiveAnchor(activeBlockId);
            }, 400);
        }

        window.addEventListener('scroll', checkVisibility);

        checkVisibility();
    }
}
